import { render, staticRenderFns } from "./PrintCoupons.vue?vue&type=template&id=0cb0e6b6"
import script from "./PrintCoupons.vue?vue&type=script&lang=js"
export * from "./PrintCoupons.vue?vue&type=script&lang=js"
import style0 from "./PrintCoupons.vue?vue&type=style&index=0&id=0cb0e6b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports